export class Deselection {
    id: number;
    period: number;
    date: string;
    day = false;
    evening = false;
    night = false;
}
